export const PRACTICE_TOPICS = [
  {
    id: 'criminal',
    title: 'Criminal Defense',
    titleUz: 'Jinoyat ishlari bo‘yicha',
    titleRu: 'По уголовным делам',
    titleEn: 'Criminal Cases',
    description: 'Surishtiruv, dastlabki tergov, prokuratura va barcha sud instansiyalarida fuqarolar hamda mansabdor shaxslarni himoya qilish.',
    descUz: 'Surishtiruv, dastlabki tergov, prokuratura va barcha sud instansiyalarida fuqarolar hamda mansabdor shaxslarni himoya qilish.',
    descRu: 'Дознание, предварительное следствие, прокуратура и защита граждан и должностных лиц во всех судебных инстанциях.',
    descEn: 'Inquiry, preliminary investigation, prosecution, and defense of citizens and officials in all court instances.',
    itemsUz: [
      'Surishtiruv, tergov va so‘roq jarayonlarida advokat ishtiroki',
      'Iqtisodiy va soliqqa oid jinoyatlar bo‘yicha himoya strategiyasi',
      'Mansab vakolatini suiiste’mol qilish bilan bog‘liq ishlar',
      'Birinchi instansiya, apellyatsiya va Oliy sudda to‘liq himoya',
      'Qamoqqa olish ehtiyot chorasini o‘zgartirish bo‘yicha iltimosnomalar',
      'Sud hukmi ustidan shikoyat qilish va kassatsiya bosqichlari'
    ],
    itemsRu: [
      'Участие адвоката в дознании, следствии, допросах и следственных действиях',
      'Стратегия защиты по сложным экономическим и налоговым делам',
      'Защита по обвинениям в превышении должностных полномочий',
      'Полная защита в судах первой инстанции, апелляции и Верховном суде',
      'Ходатайства об изменении меры пресечения и освобождении под залог',
      'Обжалование приговоров и подача кассационных жалоб'
    ],
    itemsEn: [
      'Defense participation during interrogation, inquiry, and pretrial proceedings',
      'White-collar and tax investigation defense strategy',
      'Allegations of executive overreach and corporate malpractice',
      'Trial litigation across primary, appellate, and Supreme courts',
      'Motions to modify pretrial detention and secure bail',
      'Appeals and cassation challenges against trial verdicts'
    ]
  },
  {
    id: 'civil',
    title: 'Civil Cases',
    titleUz: 'Fuqarolik ishlari bo‘yicha',
    titleRu: 'По гражданским делам',
    titleEn: 'Civil Cases',
    description: 'Mulkiy nizolar, shartnoma majburiyatlari, yetkazilgan zararni undirish, uy-joy, meros va oilaviy nizolarni sudda hal etish.',
    descUz: 'Mulkiy nizolar, shartnoma majburiyatlari, yetkazilgan zararni undirish, uy-joy, meros va oilaviy nizolarni sudda hal etish.',
    descRu: 'Имущественные споры, договорные обязательства, возмещение ущерба, жилищные, наследственные и семейные дела в суде.',
    descEn: 'Property disputes, contractual obligations, damages recovery, housing, inheritance, and civil litigation.',
    itemsUz: [
      'Mulkiy nizolar va shartnoma majburiyatlari bo‘yicha sud da’volari',
      'Moddiy va ma’naviy zararni to‘liq hajmda undirish',
      'Meros taqsimoti va vasiyatnoma bo‘yicha nizolarni hal qilish',
      'Uy-joy va yer mulkidan foydalanish huquqlarini tiklash',
      'Nikoh shartnomalari va umumiy mulkni taqsimlash',
      'Sug‘urta va kompensatsiya to‘lovlarini sud orqali undirish'
    ],
    itemsRu: [
      'Имущественные споры и иски по договорным обязательствам',
      'Взыскание материального и морального вреда в полном объёме',
      'Разрешение наследственных споров и раздел имущества',
      'Восстановление прав на жилье и недвижимое имущество',
      'Составление брачных договоров и защита семейных активов',
      'Судебное взыскание страховых выплат и компенсаций'
    ],
    itemsEn: [
      'Property disputes and breach of contract litigation',
      'Full restitution of financial and moral damages',
      'Inheritance partition, probate disputes, and estate settlements',
      'Restoration of real property and residential rights',
      'Marital contracts and equitable asset distribution',
      'Insurance claim enforcement and damage recovery'
    ]
  },
  {
    id: 'administrative',
    title: 'Administrative Cases',
    titleUz: 'Ma’muriy ishlar bo‘yicha',
    titleRu: 'По административным делам',
    titleEn: 'Administrative Cases',
    description: 'Davlat organlari, mansabdor shaxslar va nazorat idoralari qarorlari ustidan shikoyat qilish, ma’muriy huquqbuzarliklar bo‘yicha himoya.',
    descUz: 'Davlat organlari, mansabdor shaxslar va nazorat idoralari qarorlari ustidan shikoyat qilish, ma’muriy huquqbuzarliklar bo‘yicha himoya.',
    descRu: 'Обжалование решений государственных органов и должностных лиц, защита по делам об административных правонарушениях.',
    descEn: 'Appealing decisions of government bodies and officials, defense in administrative offenses and regulatory disputes.',
    itemsUz: [
      'Davlat organlarining noqonuniy qarorlari va harakatlari ustidan shikoyat',
      'Ma’muriy huquqbuzarliklar bo‘yicha sudlarda ishonchli himoya',
      'Soliq, bojxona va litsenziya organlari qarorlarini bekor qilish',
      'Mansabdor shaxslarning harakatsizligi ustidan sudga shikoyat kiritish',
      'Ma’muriy jarimalar va taqiqlarni qayta ko‘rib chiqish da’volari',
      'Tadbirkorlik faoliyatiga noqonuniy aralashuvlardan himoya'
    ],
    itemsRu: [
      'Обжалование незаконных постановлений и действий госорганов',
      'Надежная судебная защита по административным правонарушениям',
      'Отмена незаконных решений налоговых и таможенных органов',
      'Обжалование бездействия должностных лиц в судебном порядке',
      'Оспаривание административных штрафов и предписаний',
      'Защита бизнеса от незаконного вмешательства регуляторов'
    ],
    itemsEn: [
      'Challenging unlawful regulatory decisions and governmental actions',
      'Trial defense in administrative offense proceedings',
      'Overturning unlawful tax, customs, and licensing orders',
      'Litigating official inaction and administrative misconduct',
      'Challenging administrative citations, penalties, and embargoes',
      'Shielding enterprise operations from improper regulatory interference'
    ]
  },
  {
    id: 'economic',
    title: 'Economic & Commercial Cases',
    titleUz: 'Iqtisodiy ishlar bo‘yicha',
    titleRu: 'По экономическим делам',
    titleEn: 'Economic & Commercial Cases',
    description: 'Xo‘jalik va biznes nizolari, shartnomaviy qarzlar va peniyalarni undirish, bankrotlik, soliq va korporativ nizolarda vakillik.',
    descUz: 'Xo‘jalik va biznes nizolari, shartnomaviy qarzlar va peniyalarni undirish, bankrotlik, soliq va korporativ nizolarda vakillik.',
    descRu: 'Хозяйственные и коммерческие споры, взыскание задолженностей и пеней, банкротство, налоговые и корпоративные дела.',
    descEn: 'Commercial and business disputes, recovery of debts and penalties, bankruptcy, tax, and corporate representation.',
    itemsUz: [
      'Tadbirkorlar va korxonalar o‘rtasidagi xo‘jalik nizolarini sudda hal qilish',
      'Debitorlik qarzdorligi, yetkazilgan zarar va peniyalarni undirish',
      'Shartnomalarni haqiqiy emas deb topish yoki bekor qilish da’volari',
      'Bankrotlik va to‘lovga qobiliyatsizlik jarayonlarida kreditorlar himoyasi',
      'Ta’sischilar va aksiyadorlar o‘rtasidagi korporativ nizolar',
      'Tashqi iqtisodiy shartnomalar va yetkazib berish bo‘yicha xo‘jalik nizolari'
    ],
    itemsRu: [
      'Разрешение хозяйственных споров между компаниями в суде',
      'Взыскание дебиторской задолженности, убытков и неустоек',
      'Признание договоров и сделок недействительными',
      'Защита интересов кредиторов и должников в процедурах банкротства',
      'Корпоративные споры между учредителями и акционерами',
      'Споры по внешнеэкономическим контрактам и поставкам'
    ],
    itemsEn: [
      'Commercial dispute litigation between corporate entities',
      'Recovery of outstanding receivables, losses, and contractual penalties',
      'Court actions for declaration of invalidity or contract rescission',
      'Creditor and debtor representation in bankruptcy proceedings',
      'Corporate governance and shareholder dispute litigation',
      'Cross-border commercial contract and supply disputes'
    ]
  }
];
